import React from 'react'
import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import { useTheme } from '@mui/material/styles'
import { isWeekend } from 'date-fns/isWeekend'
import { getSubDatePadding } from './utils'

import './CalendarTableCell.css'

export const CalendarTableCell = ({
    colNumber,
    date,
    isExRightsDate,
    isIncRightsDate,
    isRightsEndDate,
    isSubStartDateBeforeCalendarStart,
    isSubEndDateAfterCalendarEnd,
    isIpoTradingDate,
    isSubDate,
    isSubStartDate,
    isSubEndDate,
    onMouseLeave,
    onMouseOver,
    showSubLabel,
}: {
    colNumber: number
    date: string
    isExRightsDate: boolean
    isIncRightsDate: boolean
    isRightsEndDate: boolean
    isSubStartDateBeforeCalendarStart: boolean
    isSubEndDateAfterCalendarEnd: boolean
    isIpoTradingDate: boolean
    isSubDate: boolean
    isSubStartDate: boolean
    isSubEndDate: boolean
    onMouseLeave: (e: React.MouseEvent<HTMLTableCellElement>) => void
    onMouseOver: (e: React.MouseEvent<HTMLTableCellElement>) => void
    showSubLabel: boolean
}) => {
    const theme = useTheme()

    return (
        <TableCell
            align='center'
            sx={{
                background: isWeekend(new Date(date)) ? theme.palette.grey[200] : null,
            }}
            className={['calendar-table-cell', `col-` + colNumber].join(' ')}
            onMouseLeave={onMouseLeave}
            onMouseOver={onMouseOver}
        >
            {isExRightsDate ? <Box className={'fill-box ex'}>Ex</Box> : null}
            {isIncRightsDate ? <Box className={'fill-box ink'}>Ink</Box> : null}
            {isRightsEndDate ? (
                <Box className={'fill-box-outer rights'}>
                    <Box className={'fill-box rights'}>TR</Box>
                </Box>
            ) : null}
            {isIpoTradingDate ? <Box className={'fill-box ipo'}>IPO</Box> : null}
            {isSubDate && !isRightsEndDate ? (
                <Box
                    className='sub-period'
                    sx={{
                        borderRadius: getSubDatePadding(
                            isSubStartDate,
                            isSubEndDate,
                            !!isSubStartDateBeforeCalendarStart,
                            !!isSubEndDateAfterCalendarEnd,
                        ),
                    }}
                >
                    {showSubLabel ? 'Teckning' : null}
                </Box>
            ) : null}
        </TableCell>
    )
}
